import { Fragment } from 'react';
import '../style.css';
import uniShuttle from '../../../assets/uni-shuttle.jpg';
import exploreMap from '../../../assets/explore-map.png';
import navigateSeat from '../../../assets/navigate-seat.png';
import AllStoresBtn from '../../../components/StoreButton/AllStoresBtn';
import DownloadPanel from '../../../components/DownloadPanel/DownloadPanel';
import SplitHero from '../../../components/SplitHero/SplitHero';

const EVTrains = () => {
  const content = {
    title: 'Ready to ride? Tap and explore!',
    subtext: "Booking your EV train journey is simple with Tap n' Go.",
    img: navigateSeat,
    steps: [
      "Download the Tap n' Go app and sign up.",
      'Set your departure and destination station.',
      'Choose your preferred train and carriage.',
      "Done, tap n' go!",
    ],
  };

  return (
    <Fragment>
      <SplitHero
        image={uniShuttle}
        imageAlt="EV train"
        title="Rail Travel, Reimagined"
        subtitle="Clean electric trains, real-time schedules, and contactless boarding — all in one app. Tap n' Go makes rail travel as easy as a tap."
      >
        <AllStoresBtn />
      </SplitHero>

      <section>
        <div className="content__wrapper secondary">
          <div className="content">
            <h2>Explore the rail network</h2>
            <div className="image">
              <img src={exploreMap} alt="Train route map" />
            </div>
            <div className="content__txt">
              <h2>Explore the rail network</h2>
              <p className="mt-6 text-base text-subtext">
                Browse all active EV train routes, check live departures, and
                plan multi-stop journeys — all before you leave home.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="content__wrapper">
          <div className="content row-reverse">
            <h2>Reserve your seat</h2>
            <div className="image">
              <img src={uniShuttle} alt="Train carriage" />
            </div>
            <div className="content__txt">
              <h2>Reserve your seat</h2>
              <p className="mt-6 text-base text-subtext">
                Pick your train, choose your carriage, and lock in your seat in
                seconds. Your ticket lives in the app — no printing needed.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="content__wrapper">
          <div className="content">
            <div className="image">
              <img src={content.img} alt="" />
            </div>
            <div className="content__txt">
              <h2 className="persist">{content.title}</h2>
              <p style={{ maxWidth: '40ch' }} className="text-subtext">
                {content.subtext}
              </p>

              <div className="stepper__container">
                {content.steps.map((step, idx) => (
                  <div
                    key={idx}
                    className="stepper__item font-medium text-default"
                  >
                    {step}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

<DownloadPanel />
    </Fragment>
  );
};

export default EVTrains;
